<template>
    <div class="group backdrop-blur-sm bg-zinc-900/50 rounded-lg overflow-hidden hover:bg-zinc-900 transition-all duration-300">
        <!-- Imagem -->
        <div class="aspect-video w-full">
            <img :src="project.image" :alt="$t(project.titleKey)" class="w-full h-full object-cover" />
        </div>

        <!-- Conteúdo -->
        <div class="p-6">
            <h3 class="text-xl font-bold text-white mb-2">{{ $t(project.titleKey) }}</h3>
            <p class="text-gray-300 mb-4">{{ $t(project.descriptionKey) }}</p>

            <!-- Tecnologias -->
            <div class="flex flex-wrap gap-2 mb-4">
                <span v-for="tech in project.technologies"
                      :key="typeof tech === 'string' ? tech : tech.slug"
                      class="px-2 py-1 bg-zinc-800 text-gray-300 text-sm rounded inline-flex items-center gap-1.5">
                    <svg v-if="typeof tech !== 'string'"
                         viewBox="0 0 24 24"
                         class="w-4 h-4 shrink-0"
                         :style="{ fill: '#' + tech.hex }"
                         aria-hidden="true">
                        <path :d="tech.path" />
                    </svg>
                    {{ typeof tech === 'string' ? tech : tech.title }}
                </span>
            </div>

            <!-- Links -->
            <div class="flex gap-4">
                <a v-if="project.demoLink"
                   :href="project.demoLink"
                   target="_blank"
                   class="text-gray-400 hover:text-white transition-colors">
                    <Globe class="w-5 h-5" />
                </a>
                <a v-if="project.githubLink"
                   :href="project.githubLink"
                   target="_blank"
                   class="text-gray-400 hover:text-white transition-colors">
                    <siGithub class="w-5 h-5" />
                </a>
                <a v-if="project.itchioLink"
                   :href="project.itchioLink"
                   target="_blank"
                   class="text-gray-400 hover:text-white transition-colors">
                    <siItchdotio class="w-5 h-5" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Globe } from 'lucide-vue-next';
import { siGithub, siItchdotio } from 'simple-icons';
import type { Project } from '@/data/projects';

defineProps<{
    project: Project;
}>();
</script>
